import { useAuth } from '@/hooks/useAuth';
import BesoinsPanel from '@/components/feature/BesoinsPanel';

/** Page « Besoins » du tableau de bord commerçant. */
export default function BesoinsPage() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div className="p-4 md:p-6">
      <BesoinsPanel user={user} />
    </div>
  );
}